import { DomainBase } from "./DomainBase";

export class ModifierCategoryClass extends DomainBase {
  constructor() {
    super();
    this.name = "";
  }
}
